/* Câu chuyện thương hiệu : vidéo d'ambiance du hero et vidéo « lối sống » au clic.
   Sans JS : posters et images seulement (la page reste complète). */
(() => {
  if (window.storyReady) return;
  window.storyReady = true;
  const $ = (s, r = document) => r.querySelector(s);
  let store = null;
  try { store = window.sessionStorage; } catch (e) { store = null; }
  const KEY = 'cf-story-hero';

  /* ---------- Hero : lecture auto silencieuse, seulement si visible ---------- */
  const video = $('[data-story-video]');
  const btn = $('[data-story-toggle]');
  const conn = navigator.connection || {};
  const slow = conn.saveData === true || /(^|-)2g$/.test(conn.effectiveType || '');
  if (video && btn && !slow) {
    const saved = store && store.getItem(KEY);
    const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    // Lecture voulue : pas avec « réduire les animations », sauf si le visiteur a lui-même lancé la vidéo.
    let wanted = saved === 'playing' || (!reduce && saved !== 'paused');
    let visible = false;
    let loaded = false;
    const sync = () => {
      const on = !video.paused;
      btn.classList.toggle('is-playing', on);
      btn.setAttribute('aria-label', btn.dataset[on ? 'labelPause' : 'labelPlay']);
      video.classList.toggle('is-on', on || video.currentTime > 0);
    };
    const load = () => {
      if (loaded) return;
      loaded = true;
      const mobile = matchMedia('(max-width: 749px)').matches;
      const poster = video.dataset[mobile ? 'posterMobile' : 'posterDesktop'];
      if (poster) video.poster = poster;
      video.src = video.dataset[mobile ? 'srcMobile' : 'srcDesktop'];
    };
    const play = () => {
      load();
      const p = video.play();
      if (p && p.catch) p.catch(() => { wanted = false; sync(); });
    };
    btn.hidden = false;
    video.addEventListener('play', sync);
    video.addEventListener('pause', sync);
    btn.addEventListener('click', () => {
      wanted = video.paused;
      if (store) store.setItem(KEY, wanted ? 'playing' : 'paused');
      if (wanted) play(); else video.pause();
    });
    const io = new IntersectionObserver(([e]) => {
      visible = e.isIntersecting;
      if (visible && wanted) play();
      else if (!visible && !video.paused) video.pause();
    }, { threshold: 0.25 });
    io.observe(video.closest('[data-story-hero]'));
    sync();
  }

  /* ---------- Lối sống : la vidéo n'est chargée qu'au clic (façade) ---------- */
  document.addEventListener('click', (e) => {
    const a = e.target.closest('[data-story-play]');
    if (!a) return;
    e.preventDefault();
    const box = document.createElement('div');
    box.className = a.className;
    while (a.firstChild) box.append(a.firstChild);
    const v = Object.assign(document.createElement('video'), { controls: true, muted: true, autoplay: true, playsInline: true, preload: 'auto' });
    v.setAttribute('aria-label', a.getAttribute('aria-label') || '');
    if (a.dataset.track) {
      v.crossOrigin = 'anonymous';
      v.append(Object.assign(document.createElement('track'), { kind: 'subtitles', srclang: 'vi', label: 'Tiếng Việt', src: a.dataset.track, default: true }));
    }
    v.src = a.dataset.src;
    box.append(v);
    a.replaceWith(box);
    v.focus();
    const p = v.play();
    if (p && p.catch) p.catch(() => {});
  });
})();
